import type { HeaderSize } from './basic-content-settings.model';

export const standardHeadingSize = (colWidth?: number): HeaderSize =>
  !colWidth ? '' : colWidth >= 6 ? 'h2' : colWidth >= 4 ? 'h3' : 'h4';

export const standardSubheadingSize = (colWidth?: number): HeaderSize =>
  !colWidth ? '' : colWidth >= 6 ? 'h3' : colWidth >= 4 ? 'h4' : 'h5';
